import { MouseEventHandler } from "react";
import { useDispatch } from "react-redux";

import { CaseDocumentAdmin } from "pwapi";

import { updateAdminDocument } from "shared/actions/admin/adminDocumentsActions";

import DocumentsForm from "./DocumentsForm";

type EditDocumentsFormProps = {
  document: CaseDocumentAdmin;
  onDelete: Function;
  onClose: MouseEventHandler<HTMLButtonElement>;
};

const EditDocumentsForm = ({
  document,
  onDelete,
  onClose,
}: EditDocumentsFormProps) => {
  const dispatch = useDispatch();

  const handleOnSubmit = (values: any) => {
    const submitForm = {
      id: document.id,
      case_id: values.case ? values.case.id : document.case_id,
      case__accession: values.case
        ? values.case.accession
        : document.case__accession,
      category: values.category,
      status: values.status,
      name: values.name,
    };

    dispatch(updateAdminDocument(submitForm, onClose));
  };

  return (
    <DocumentsForm
      document={document}
      onSubmit={handleOnSubmit}
      onDelete={onDelete}
      onClose={onClose}
    />
  );
};

export default EditDocumentsForm;
